/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file AntiBodyAntiHBsView.jsx
 * @author Daniel Aguirre
 * @description AntiBodyAntiHBs View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import DashboardTitle from 'components/Charts/DashboardTitle';
import ProgressBar from 'components/Charts/ProgressBar';
import { useHistory } from 'react-router';
import styleGuideColors from 'commons/styleGuideColors';
import EmptyChart from 'components/EmptyChart';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * AntiBodyAntiHBs View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function AntiBodyAntiHBsView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getAntibodyAntiHBs } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    const data = [];
    const colors = {
      'Si cumplen': styleGuideColors.baxterBrandTeal,
      'Próximos a vencer': styleGuideColors.graphYellow,
      Vencidos: styleGuideColors.alertError
    };
    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      resp.data.forEach(({ cantidad, clasificacion }) => {
        const percent = (cantidad * 100) / total;
        const item = {
          title: cantidad,
          subtitle: clasificacion,
          percent: useTruncateAndFormat(percent, 2),
          color: colors[clasificacion]
        };
        if (clasificacion === 'Si cumplen') {
          data[0] = item;
        } else if (clasificacion === 'Próximos a vencer') {
          data[1] = item;
        } else if (clasificacion === 'Vencidos') {
          data[2] = item;
        }
      });
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getAntibodyAntiHBs({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    // Get data by index and send by url param to detail list
    const { title: totalItems, subtitle: classification } = chartData[index];
    history.push(
      `/main/dashboard-detail/antibody-anti-hbs/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F10" loading={!chartData}>
      <div className="flex flex-wrap">
        <DashboardTitle title={translate('dashboardStaff.antiBodyAntiHBs')} />
        <div className="px-2 w-full">
          {chartData?.length === 0 && <EmptyChart />}
          {chartData?.map(({ color, title, subtitle, percent }, index) => (
            <div onClick={() => handleDetailClick(index)} key={index}>
              <ProgressBar
                color={color}
                title={title}
                subtitle={subtitle}
                percent={percent}
              />
            </div>
          ))}
        </div>
      </div>
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
AntiBodyAntiHBsView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getAntibodyAntiHBs: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default AntiBodyAntiHBsView;
